import { z } from 'zod';

import { AdminBatchStatisticsSchema } from './AdminBatchStatisticsSchema';

export const AdminFixSentDeclarationsResponseSchema = z.object({
  declarationsModifiedCount: z.number(),
});

export type AdminFixSentDeclarationsResponse = z.infer<typeof AdminFixSentDeclarationsResponseSchema>;

export const AdminChangeStatusDeclarationsResponseSchema = z.object({
  modifiedCount: z.number(),
  updatedStatistics: AdminBatchStatisticsSchema,
});

export type AdminChangeStatusDeclarationsResponse = z.infer<typeof AdminChangeStatusDeclarationsResponseSchema>;

export const AdminReassignDeclarationsResponseSchema = z.object({
  sourceBatch: z.number(),
  destinationBatch: z.number(),
});

export type AdminReassignDeclarationsResponse = z.infer<typeof AdminReassignDeclarationsResponseSchema>;

export const AdminHardDeleteDeclarationsResponseSchema = z.object({
  batchCounter: z.number(),
  deletedCounter: z.number(),
  statistics: AdminBatchStatisticsSchema,
});

export type AdminHardDeleteDeclarationsResponse = z.infer<typeof AdminHardDeleteDeclarationsResponseSchema>;

export const AdminUpdateDeclarationsResponseSchema = z.object({
  data: z.object({
    acknowledged: z.boolean(),
    matchedCount: z.number(),
    modifiedCount: z.number(),
    upsertedCount: z.number(),
    upsertedId: z.string().nullable(),
  }),
});

export type AdminUpdateDeclarationsResponse = z.infer<typeof AdminUpdateDeclarationsResponseSchema>;
